import React from "react";
import { CountBadge } from "./Badge";
import { selectionClass, tabSizeClass } from "./tabStyles";

export { selectionClass, tabSizeClass } from "./tabStyles";

/** Product section tabs — School, dashboards, Host profile. */
export function readableTabClass(active, { disabled = false } = {}) {
  return `${tabSizeClass("default")} ${selectionClass(active, { disabled })}`;
}

/** Full-width check-in floor/board tabs (same selected fill as product tabs). */
export function checkInTabClass(active) {
  return `${tabSizeClass("checkin")} ${selectionClass(active)}`;
}

/** @deprecated Alias of checkInTabClass — demo and live share one selected treatment. */
export function checkInDemoTabClass(active) {
  return checkInTabClass(active);
}

export default function TabButton({
  tabKey,
  active,
  onClick,
  children,
  testid,
  badge = null,
  panelId,
  variant = "default",
  className = "",
  ...rest
}) {
  const isCheckin = variant === "checkin" || variant === "checkinDemo";
  const tabClass = isCheckin ? checkInTabClass(active) : readableTabClass(active);
  return (
    <button
      type="button"
      role="tab"
      id={testid}
      data-tab-key={tabKey}
      aria-selected={active}
      aria-controls={panelId}
      tabIndex={active ? 0 : -1}
      onClick={onClick}
      className={`${tabClass} ${className}`.trim()}
      data-testid={testid}
      {...rest}
    >
      {children}
      {variant === "default" ? <CountBadge count={badge} className="ml-0.5" /> : null}
    </button>
  );
}
